// extracted by mini-css-extract-plugin
export default {"draft-block":"DraftBlock_draft-block__Iqyxc","remove-block":"DraftBlock_remove-block__JsBj2","add-block":"DraftBlock_add-block__Wknkw"};